"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateResource = exports.getRouterList = exports.getResourceTreeList = exports.getResourceIdListByRoleId = exports.getMenuList = exports.deleteResourceById = exports.addResource = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加模块
 * @param module
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addResource = exports.addResource = function addResource(module) {
  return _api.default.request({
    url: '/system/resource/save',
    method: 'post',
    data: module
  });
};

/**
 * 修改模块
 * @param module
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateResource = exports.updateResource = function updateResource(module) {
  return _api.default.request({
    url: '/system/resource/update',
    method: 'post',
    data: module
  });
};

/**
 * 删除模块
 * @param moduleId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteResourceById = exports.deleteResourceById = function deleteResourceById(moduleId) {
  return _api.default.request({
    url: '/system/resource/delete',
    method: 'post',
    params: {
      id: moduleId
    }
  });
};

/**
 * 获取模块tree-table数据
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getResourceTreeList = exports.getResourceTreeList = function getResourceTreeList() {
  return _api.default.request({
    url: '/system/resource/getResourceTreeList'
  });
};

/**
 * 获取菜单列表
 * @returns {AxiosPromise}
 */
var getMenuList = exports.getMenuList = function getMenuList() {
  return _api.default.request({
    url: '/system/resource/getMenuList'
  });
};

/**
 * 获取tree列表数据
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getResourceIdListByRoleId = exports.getResourceIdListByRoleId = function getResourceIdListByRoleId(roleId) {
  return _api.default.request({
    url: '/system/resource/getResourceIdListByRoleId',
    params: {
      roleId: roleId
    }
  });
};

/**
 * 根据登录人获取目录和菜单路由
 * @returns {AxiosPromise}
 */
var getRouterList = exports.getRouterList = function getRouterList() {
  return _api.default.request({
    url: '/user/userInfo',
    method: 'post'
  });
  // return axios.request({
  //   url: '/system/resource/getRouterList'
  // })
};